import { render, staticRenderFns } from "./expenses-types.vue?vue&type=template&id=07c9e189&scoped=true"
import script from "./expenses-types.vue?vue&type=script&lang=js"
export * from "./expenses-types.vue?vue&type=script&lang=js"
import style0 from "./expenses-types.vue?vue&type=style&index=0&id=07c9e189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c9e189",
  null
  
)

export default component.exports